import React, { useContext } from 'react';
import { IStoreAvailabilityData, StoreLocatorType } from '../storeLocatorTypes';
import { openStoreLocatorSidebar } from '../storeLocatorSidebarState';
import AloRadioButton from 'src/scripts/templates/_shared/ui-components/YogaUI/AloRadioButton';
import { ProductContext } from '../../../ProductContext';
import styles from './style.module.scss';

let StoreLocatorTileTitle = ({
  store,
  storeLocatorType,
}: {
  store: IStoreAvailabilityData;
  storeLocatorType: StoreLocatorType;
}) => {
  const { sidebarPdpData } = useContext(ProductContext);

  function trimNumbersFromString(name: string) {
    const trimmedString = name.replace(/\d+/g, '');
    return trimmedString.trim();
  }

  return (
    <div className={styles.storeNameWrapper}>
      <div>
        <AloRadioButton
          label={<label className="body-small semibold">{trimNumbersFromString(store.name)}</label>}
          groupName={`selectedStore`}
          value={store.location_id}
          checked={true}
          stopPropagation={true}
        />
      </div>
      <div className={styles.detailsLink}>
        <span
          role="button"
          className="body-small semibold underline"
          onClick={() => {
            openStoreLocatorSidebar({
              feature: storeLocatorType,
              pdpProps: sidebarPdpData || undefined,
              page: 'pdp',
            });
          }}
        >
          Details
        </span>
      </div>
    </div>
  );
};

export { StoreLocatorTileTitle };
